import React from "react";
import { Provider } from "react-redux";
import ToastDisplay from "../../user/view/components/common/toast";
import configStore from "../controller/configStore";
import services from "../data/index";
import Home from "./components/Home";

function App() {
  return (
    <Provider store={configStore(services)}>
      <Home />
      <ToastDisplay />
    </Provider>
  );
}

export default App;
